import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigContext } from './config-context';
export var ConfigProvider = function ConfigProvider(props) {
    var children = props.children, config = props.config;
    return (_jsx(ConfigContext.Provider, { value: config, children: children }));
};
